import { Controller } from "@hotwired/stimulus";
import { loadStripe } from "@stripe/stripe-js";

export default class extends Controller {
  static targets = ["errorToast"];

  async connect() {
    this.stripe = await loadStripe(this.element.dataset.publicKey);
  }

  async loadFlow(event) {
    event.preventDefault();

    const response = await fetch("/settings/bank_accounts/stripe_setup_intents_create", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content,
      },
      credentials: "same-origin",
    }).catch(() => null);
    if (!response?.ok) return this.showError();

    this.clientSecret = (await response.json()).client_secret;

    this.stripe
      .collectBankAccountForSetup({
        clientSecret: this.clientSecret,
        params: {
          payment_method_type: "us_bank_account",
          payment_method_data: {
            billing_details: {
              name: this.element.dataset.userName,
              email: this.element.dataset.userEmail,
            },
          },
        },
        expand: ["payment_method"],
      })
      .then(({ setupIntent, error }) => {
        if (error) {
          this.showError();
        } else if (setupIntent.status === "requires_confirmation") {
          this.confirmBankAccount();
        }
      });
  }

  confirmBankAccount() {
    this.showLoader();
    this.stripe.confirmUsBankAccountSetup(this.clientSecret).then(({ setupIntent, error }) => {
      const linked =
        setupIntent?.status === "succeeded" ||
        setupIntent?.next_action?.type === "verify_with_microdeposits";

      if (!error && linked) {
        this.createBankAccount(setupIntent);
      } else {
        this.fail();
      }
    });
  }

  createBankAccount(setupIntent) {
    fetch("/settings/bank_accounts/debit_account_create", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content,
      },
      credentials: "same-origin",
      body: JSON.stringify({
        stripe_payment_method_id: setupIntent.payment_method,
        stripe_setup_intent_id: setupIntent.id,
      }),
    })
      .then((response) => {
        if (response.redirected) {
          window.location.href = response.url;
        } else {
          this.fail();
        }
      })
      .catch(() => this.fail());
  }

  fail() {
    this.hideLoader();
    this.showError();
  }

  showError() {
    document
      .querySelector("#notification-tray")
      .append(this.errorToastTarget.content.cloneNode(true));
  }

  hideLoader() {
    document.querySelector("#page-loader").classList.add("hidden");
  }

  showLoader() {
    document.querySelector("#page-loader").classList.remove("hidden");
  }
}
